import { BaseIcon } from './BaseIcon';

const LogoutIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M14 20H6C4.89543 20 4 19.1046 4 18L4 6C4 4.89543 4.89543 4 6 4H14M10 12H21M21 12L18 15M21 12L18 9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default LogoutIcon;
